import React from 'react'

import PopupMenuButton from "../../popover-menu/popup-menu-button/popup-menu-button"
import ControlButtonStandard from "../../buttons/control-button/control-button-standard"
import RelatedItemsPopover, {RelatedItemsPopoverParams} from "./popover"
import {RELATED_ITEMS_ADD_POPOVER_CLASS} from "../common/add-menu"

// popoverClass of the row's "..." menu (common/more-menu.tsx).
const MORE_MENU_POPOVER_CLASS = 'gd-view-more-popover'

type Props = RelatedItemsPopoverParams & {
    className?          : string
    hint?               : string

    onTogglePopover?    : {(value: boolean): void}
}

// Control button opening the Related Items popover, shared by the page view and
// the document view.
//
// Built on PopupMenuButton rather than ControlButtonMenu because the button body
// is not just an icon: it carries the count, so it needs btnComponent.
//
// The icon goes through iconClass, NOT ControlButtonType -- that enum has no
// relation entry, and its types map throws on a type it does not know.
export default function RelatedItemsControlButton(props: Props) {

    const {relations, canEdit, onAdd, onRemove} = props
    const count = relations.models.length

    const btnComponent = (state: any) => {
        const classes = Classes(props.className, {
            'show-popover': state.showPopover
        })

        // Icon only at zero: the count would read as "0 related items" when the
        // whole point of the button in that state is to add the first one. That
        // keeps the default square button; with a count it has to grow, hence the
        // horizontal padding and the icon moving into the body.
        if (count === 0) {
            return <ControlButtonStandard className = {classes}
                                          iconClass = "fs-14 i5-waypoints"
                                          hint      = {props.hint}/>
        }

        return (
            <ControlButtonStandard className = {Classes('p-l-6 p-r-6', classes)}
                                   hint      = {props.hint}>
                <span className="i5-waypoints fs-14 m-r-5"/>
                <span className="ui5-txt-not-important-small">{count}</span>
            </ControlButtonStandard>
        )
    }

    // A row's "..." menu and the Add row's type menu are Popovers of their own,
    // and Popover tethers its content to the BODY rather than nesting it -- so a
    // click in either counts as outside this one. Without the ignores it would
    // close on mousedown, unmounting that menu before its click ever landed, and
    // neither Delete nor a type choice would fire.
    // Centred under the button: PopupMenuButton defaults to "top right"/"bottom
    // right", which hangs the popover off the button's right corner.
    return <PopupMenuButton attachment                  = "top center"
                            targetAttachment            = "bottom center"
                            offset                      = "0 0"
                            btnComponent                = {btnComponent}
                            menuComponent               = {RelatedItemsPopover}
                            menuParams                  = {{relations, canEdit, onAdd, onRemove} as RelatedItemsPopoverParams}
                            outsideClickIgnoreClasses   = {[MORE_MENU_POPOVER_CLASS, RELATED_ITEMS_ADD_POPOVER_CLASS]}
                            onTogglePopover             = {props.onTogglePopover}/>
}

RelatedItemsControlButton.defaultProps = {
    hint: 'Related items',
}
